import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'CONTROLE_ROUTE_ID_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('controleRouteIdForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'CONTROLE_ROUTE_ID_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'CONTROLE_ROUTE_ID_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(documentos) {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'CONTROLE_ROUTE_ID_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/controleRouteId?id_setor=${getState().controleRouteId.filtro.id_setor}`).then(resp => {
			dispatch({
		        type: 'CONTROLE_ROUTE_ID_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
	return async (dispatch, getState) => {
		if (!registro.id) {
			await axios.post(`${consts.API_URL}/controleRouteId`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/controleRouteId`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
	};
}

export function importar(tabela) {
	return async (dispatch, getState) => {
		
		dispatch(setAguardando(true));

		if (tabela) {
			const linhas = tabela;

			//Importação da tabela pré preenchidas
			if (linhas[0][0] == 'id' && linhas[0][1] == 'codigo' && linhas[0][2] == 'id_tabela_frete_vigencia' && linhas[0][3] == 'id_tabela_frete_rota') {

				const resultado = linhas
					.slice(1)
					.filter(linha => linha && linha[0]) // ignora vazias
					.map(linha => ({
						id: linha[0],
						codigo: linha[1]
					}));

				await axios.put(`${consts.API_URL}/controleRouteId/importar`, {
					registros: resultado,
					id_usuario_alteracao: getState().auth.usuario.id
				}).then(resp => {
					setSuccess('Operação Realizada com sucesso.');
					dispatch(getLista());
				}).catch(e => {
					setErroAPI(e);
				});

			} else {			
				const extrairData = (linha) => {
					return linha.find(valor => valor instanceof Date) || null;
				};

				const linhaInicio = linhas.find(linha =>
					linha.includes('Início da Vigência')
				);

				const linhaFim = linhas.find(linha =>
					linha.includes('Fim da Vigência')
				);

				let dataInicio = linhaInicio ? extrairData(linhaInicio) : null;
				let dataFim = linhaFim ? extrairData(linhaFim) : null;

				if (dataInicio && dataFim) {
					dataInicio.setHours(dataInicio.getHours() + 12);
					dataInicio = DateFormat.getTimestampParaData(dataInicio.getTime());
					dataFim.setHours(dataFim.getHours() + 12);
					dataFim = DateFormat.getTimestampParaData(dataFim.getTime());
				}

				const headerIndex = linhas.findIndex(linha =>
					linha.includes('Cliente') &&
					linha.includes('Serviço') &&
					linha.includes('Código')
				);

				const header = linhas[headerIndex];

				const getIndex = (nome) => header.findIndex(h => h && h.trim() === nome);

				const map = {
					cliente: getIndex('Cliente'),
					rumo: getIndex('Fx'),
					servico: getIndex('Serviço'),
					id_rota: getIndex('Rota KMM'),
					mercadoria: getIndex('Merc'),
					tipo_veiculo: getIndex('Veí'),
					fronteira: getIndex('Front'),
					codigo: getIndex('Código')
				};

				const resultado = linhas
					.slice(headerIndex + 1)
					.filter(linha => linha && linha[map.cliente]) // ignora vazias
					.map(linha => ({
						data_inicio_vigencia: dataInicio,
						data_fim_vigencia: dataFim,
						cliente: linha[map.cliente],
						rumo: linha[map.rumo],
						servico: linha[map.servico],
						id_rota: linha[map.id_rota],
						mercadoria: linha[map.mercadoria],
						tipo_veiculo: linha[map.tipo_veiculo],
						fronteira: linha[map.fronteira],
						codigo: linha[map.codigo]
					}));

				await axios.put(`${consts.API_URL}/controleRouteId/importar`, {
					registros: resultado,
					id_usuario_alteracao: getState().auth.usuario.id
				}).then(resp => {
					setSuccess('Operação Realizada com sucesso.');
					dispatch(getLista());
				}).catch(e => {
					setErroAPI(e);
				});
				
			}
				
		}

		dispatch(setAguardando(false));
	};
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/controleRouteId?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function baixarModelo() {
	return (dispatch, getState) => {
	
    	axios.get(`${consts.API_URL}/controleRouteId/modeloImportacao`, {
			responseType: 'blob'
		}).then(response => {
			// cria URL do arquivo
			const url = window.URL.createObjectURL(new Blob([response.data]));

			// tenta pegar nome do backend
			let filename = 'modelo.xlsx';
			const disposition = response.headers['content-disposition'];

			if (disposition) {
				const match = disposition.match(/filename="?(.+)"?/);
				if (match && match[1]) {
					filename = match[1];
				}
			}

			// cria link e baixa
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();

			link.remove();
			window.URL.revokeObjectURL(url);
		}).catch(e => {
			setErroAPI(e);
		});
	}
}
